import React, {Component} from 'react';
import {HashRouter as Router, Switch, Route} from 'react-router-dom';
import PropTypes from 'prop-types';
import Auth from './auth/auth';
import NavigationBar from './navigation-bar/navigation-bar';
import Dashboard from './dashboard/dashboard';
import ExpoList from './expo-list/expo-list';
import ExpoEditor from './expo-editor/expo-editor';
import ShowEditor from './show-editor/show-editor';
import ShowbagEditor from './showbag-editor/showbag-editor.js';
import EntryEditor from './entry-editor/entry-editor';
import LobbyEditor from './lobby-editor/lobby-editor';
import BoothList from './booth-list/booth-list';
import BoothEditor from './booth-editor/booth-editor';
import BoothReviewer from './booth-reviewer/booth-reviewer';
import HallList from './hall-list/hall-list';
import HallEditor from './hall-editor/hall-editor';
import GiftCardEditor from './gift-card-editor/gift-card-editor';
import ReportList from './report-list/report-list';

/** @module Editor
  * A component for editing an exposition and
  * its shows.
  * @param {string} expoID (optional) - the id of the expo
  * @param {string} showID (optional) - the id of the show
  */
export default class Editor extends Component {
  render() {
    return (
      <Router>
        <Auth>
          <Switch>
            <Route path={"/expos/:expoID/shows/:showID/"} component={NavigationBar}/>
            <Route path={"/expos/:expoID/"} component={NavigationBar}/>
            <Route path="/" component={NavigationBar}/>
          </Switch>
          <Switch>
            <Route path={"/expos"} exact={true} component={ExpoList}/>
            <Route path={"/expos/:expoID"} exact={true} component={ExpoEditor}/>
            <Route path={"/expos/:expoID/shows/:showID"} exact={true} component={ShowEditor}/>
            <Route path={"/expos/:expoID/shows/:showID/showbag"} component={ShowbagEditor}/>
            <Route path={"/expos/:expoID/shows/:showID/entry"} component={EntryEditor}/>
            <Route path={"/expos/:expoID/shows/:showID/lobby"} component={LobbyEditor}/>
            <Route path={"/expos/:expoID/shows/:showID/halls"} exact={true} component={HallList}/>
            <Route path={"/expos/:expoID/shows/:showID/halls/:hallID"} exact={true} component={HallEditor}/>
            <Route path={"/expos/:expoID/shows/:showID/booths"} exact={true} component={BoothList}/>
            <Route path={"/expos/:expoID/shows/:showID/booths/:boothID"} exact={true} component={BoothEditor}/>
            <Route path={"/expos/:expoID/shows/:showID/booths/:boothID/review"} exact={true} component={BoothReviewer}/>
            <Route path={"/expos/:expoID/shows/:showID/gift-cards"} exact={true} component={GiftCardEditor}/>
            <Route path={"/expos/:expoID/shows/:showID/reports"} exact={true} component={ReportList} />
            <Route path={"/"} component={Dashboard}/>
          </Switch>
        </Auth>
      </Router>
    )
  }
}

Editor.propTypes = {
  expoID: PropTypes.string,
  showID: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/editor.js